import { Tab } from 'types'

/** @deprecated Legacy table headers — kept for unused table components */
export const addressTableHeaders: Tab[] = [
  { id: 'customer', label: 'Customer' },
  { id: 'term', label: 'Term' },
  { id: 'currency', label: 'Currency' },
  { id: 'factored', label: 'Factored' },
  { id: 'waybill', label: 'Waybill' },
  { id: 'action', label: 'Action' },
]

export const addressEntityTabs: Tab[] = [
  { id: 'customer', label: 'Customer' },
  { id: 'shipper', label: 'Shipper', disabled: true },
  { id: 'carrier', label: 'Carrier' },
]

export const carrierDetailTabs: Tab[] = [
  { id: 'carrier', label: 'Carrier' },
  { id: 'document', label: 'Documents' },
]

export const customerDetailTabs: Tab[] = [
  { id: 'company-name', label: 'Company Name' },
  { id: 'address', label: 'Address' },
  { id: 'email', label: 'Email' },
  { id: 'phone', label: 'Phone' },
  { id: 'document', label: 'Document' },
]

export const EMAIL_TYPES = [
  { value: 'NotificationEmail' as const, label: 'Dispatch' },
  { value: 'InvoicePodEmail' as const, label: 'Invoice / POD' },
  { value: 'AccountPayableEmail' as const, label: 'Account Payable' },
]

export const PHONE_TYPES = [
  { value: 'Dispatch' as const, label: 'Dispatch' },
  { value: 'InvoicePOD' as const, label: 'Invoice / POD' },
  { value: 'AccountPayable' as const, label: 'Account Payable' },
  { value: 'DispatchAfterHoursPhone' as const, label: 'Dispatch After Hours' },
  { value: 'DispatchCell' as const, label: 'Dispatch Cell' },
]
